export * from './antd-holder-icon';
